var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebooklogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook logo",
    clipPath: "url(#clip0_116_372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.78645 14V7.43079H-0.000488281V5.06556H1.78645V3.04535C1.78645 1.45785 2.842 0 5.27422 0C6.25898 0 6.98717 0.09177 6.98717 0.09177L6.92979 2.30049C6.92979 2.30049 6.18716 2.29347 5.37676 2.29347C4.49967 2.29347 4.35914 2.68638 4.35914 3.33851V5.06556H6.99951L6.88463 7.43079H4.35914V14H1.78645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    fill: "white",
    transform: "translate(-0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooklogo);
export default __webpack_public_path__ + "static/media/facebook logo.91d5c6cd85f5b9751edcac8a9b3411d4.svg";
export { ForwardRef as ReactComponent };